// extracted by mini-css-extract-plugin
export default {"horizontal":"MatchUp_horizontal--GmU","item":"MatchUp_item--Hgn","vertical":"MatchUp_vertical--khW","title":"MatchUp_title--XO_"};